import { MetaDefinition } from '@angular/platform-browser';

export type HomeDataResponse = Readonly<{
  code: string;
  logo_url: string;
  title: string;
  sub_title: string,
  footer_operated_by: string;
  store_type: string;
  branch_code: string;
  sections: HomeSection[];
  banners: HomeBanner[];
  metas?: MetaDefinition[];
  footer_content?: string;
  login_required: boolean;
  widgets: string;
  product_references?: string[];
  visibility_only_prime?: boolean;
}>;

export type HomeBanner = Readonly<{
  image_url: string;
  deeplink: string;
  desktop_image_url: string;
  deeplink_type?: HomeDeeplinkType;
}>;

export type HomeSection = Readonly<{
  title: string;
  sub_title?: string;
  promos?: HomePromo[];
  stores?: HomeStore[];
  banners?: HomeBanner[];
  text?: string,
  tiles?: HomeStore[];
  recentSearchs?: HomeRecentSearch[];
  hotel_promos: HomeHotelPromo[];
  is_cashback: boolean;
  exclusive_rappi_card: boolean;
}>;

export type HomePromo = Readonly<{
  title: string;
  sub_title: string;
  image_url: string;
  currency: string;
  price_from: number;
  discount_percent: number;
  price_from_before_discount: number;
  deeplink: string;
  deeplink_type?: HomeDeeplinkType;
}>;

export type HomeStore = Readonly<{
  title: string;
  image_url: string,
  desktop_image_url?: string;
  deeplink: string;
  deeplink_type?: HomeDeeplinkType;
}>;

export type HomeRecentSearch = Readonly<{
  type: string;
  passengers: number;
  origin?: string;
  destination: string;
  arrival_date?: string;
  departure_date?: string;
  check_in?: string;
  check_out?: string;
}>;

export type HomeHotelPromo = Readonly<{
  ammenities: number[];
  breakfast_included: boolean;
  cashback_percent: number;
  currency: string;
  free_cancelation: boolean;
  hotel_name: string;
  image_url: string;
  price_from: number;
  discount_percent: number;
  score: number;
  stars: number;
  zone: string;
  deeplink: string;
  deeplink_type?: HomeDeeplinkType;
}>;

export type HomeFlightOffers = Readonly<{
  departure: string,
  arrival: string,
  outbound: string,
  inbound: string,
  bestprice: string,
  currency: string,
  stops: number
}>;

export enum HomeDeeplinkType {
  Gbrappi = 'Gbrappi',
  WhatsApp = 'WhatsApp',
  RouterLink = 'RouterLink',
  HTMLAnchor = 'HTMLAnchor',
  External = 'RouterLinkExternal',
}
